import { useAct } from 'FlowBuilder/store'
import { useState } from 'react'
import './FieldEdit.scoped.scss'

// Parameterized function for wrapper styles
function getFieldWrapperStyles({ hasImage, minimumHeight, isHovered }) {
  const baseStyles = {
    border: '1px solid #ccc',
    borderRadius: '3px',
    padding: '0px 5px',
    position: 'relative',
    minHeight: minimumHeight,
    backgroundColor: isHovered ? '#ccc' : 'transparent',
    transition: 'background-color 0.2s',
    cursor: isHovered ? 'pointer' : 'default'
  };

  // Add additional styles for image fields
  if (hasImage) {
    return {
      ...baseStyles,
      width: '100%',
      display: 'block'
    };
  }

  return baseStyles;
}

export default function FieldEdit({ slug }) {
  const act = useAct()
  const [isHovered, setIsHovered] = useState(false)
  const field = useSel(s => s.builder.flowTemplate.fields.find(f => f.slug === slug))
  const value = useSel(s => s.builder.flow.templateFields[slug])

  const editIconStyles = {
    cursor: 'pointer',
    position: 'absolute',
    top: '0',
    right: '0px',
    width: '20px',
    height: '20px',
    backgroundColor: '#ccc',
    borderRadius: '3px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 10
  }

  function handleClick() {
    act.local.setModal({ kind: 'editContent', slug })
  }

  // Determine parameters based on field type
  const hasImage = field.image;
  const isWysiwyg = field.wysiwyg;
  const minimumHeight = hasImage ? '100px' : '30px';
  const placeholderText = hasImage ? <p style={{ marginLeft: '10px', marginTop: '0px', marginBottom: '0px' }}>Add an image</p> : 'Add some content';

  // Get wrapper styles with parameters
  const wrapperStyles = getFieldWrapperStyles({
    hasImage,
    minimumHeight,
    isHovered
  });

  // Additional wrapper style for image to support absolute positioning of placeholder
  const wrapperWithPosition = hasImage && !value ? { ...wrapperStyles, position: 'relative' } : wrapperStyles;

  // Placeholder component to show when no value exists
  const Placeholder = !value && (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      opacity: 0.6,
      fontSize: '16px',
      ...(hasImage ? {
        justifyContent: 'center',
        height: '100%',
        width: '100%',
        position: 'absolute',
        top: 0,
        left: 0
      } : {})
    }}>
      {hasImage && <SvgIconsDownload width={24} height={24} />}
      {placeholderText}
    </div>
  );

  // Function to render content based on field type
  const renderContent = () => {
    if (!value) {
      return Placeholder;
    }

    if (isWysiwyg) {
      return <div dangerouslySetInnerHTML={{ __html: value }} />;
    }

    if (hasImage) {
      if ((value || '').includes('https://')) {
        return <img src={value} alt={field.label} />;
      }
      return <img src={`/rails/active_storage/blobs/${value}/image.png`} alt={field.label} />;
    }

    return value;
  };

  return (
    <div
      style={wrapperWithPosition}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={handleClick}
    >
      {renderContent()}
      <span style={editIconStyles} onClick={(e) => {
        e.stopPropagation(); // Prevent double triggering
        handleClick();
      }}>
        <SvgIconsEdit color={'currentColor'} style={{ color: 'white' }} />
      </span>
    </div>
  );
}
